import React from 'react';
import { SkeletonProps } from '../../interfaces/SkeletonProps';
import PlaceholderBar from '../PlaceholderBar/PlaceholderBar';
import styles from './TotaliserWrapperSkeleton.scss';
import Refresh from '../Refresh/Refresh';
import { useTranslation } from 'react-i18next';

const TotaliserWrapperSkeleton: React.FunctionComponent<SkeletonProps> = ({
  animated,
  onRefresh,
  displayRefreshButton,
}) => {
  const { t } = useTranslation('common', { useSuspense: false });
  return (
    <Refresh
      className={styles.container}
      onRefresh={onRefresh}
      displayRefreshButton={displayRefreshButton}
      buttonLabel={t('page.totaliser_refresh')}
    >
      <PlaceholderBar
        animated={animated}
        width={148}
        height={148}
        className={styles.totaliser}
      />
    </Refresh>
  );
};

export default TotaliserWrapperSkeleton;
